export default Object.freeze({
  default: 9,
  transmit: 20,
});
